module.exports = __webpack_public_path__ + "static/media/close.d5338c1b.svg";